module.exports = __webpack_public_path__ + "img/teaching_3_en.ea8cbe5e.png";